import React, { useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';

const API_URL = process.env.REACT_APP_API_URL || 'https://localhost:50586/api/';

const formatAssetUrl = (url, fallback = '') => {
    if (!url) return fallback;
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) return url;
    if (url.startsWith('/img/') || url.startsWith('/static/') || url.startsWith('static/')) return url;
    const baseUrl = API_URL.replace(/\/api\/?$/, '');
    return `${baseUrl}${url.startsWith('/') ? '' : '/'}${url}`;
};

const QRPluckingRooster = ({ data, customConfig, roomId, isActiveWomensMode }) => {

    const LoadPage = async () => {
        try {
            document.getElementById("root")?.classList.add("BodyComplete");
        } catch (error) {}
    };

    useEffect(() => {
        LoadPage();
    }, []);

    const effectiveRoomId = roomId || data?.roomId || new URLSearchParams(window.location.search).get('roomId');
    const qrUrl = `${window.location.origin}/rooster${effectiveRoomId ? `?roomId=${encodeURIComponent(effectiveRoomId)}` : ''}`;

    const bgImage = customConfig?.screenBackground
        ? formatAssetUrl(customConfig.screenBackground)
        : (isActiveWomensMode ? '/img/page/backgrounds/Fondo-SelfieFan-Femenil.jpeg' : '/img/page/backgrounds/Fondo-SelfieFan-Varonil.jpeg');

    const sponsorLogo = (customConfig?.screenSponsor || customConfig?.sponsorLogo)
        ? formatAssetUrl(customConfig.screenSponsor || customConfig.sponsorLogo)
        : "/img/page/xolos-five.png";

    return (
        <>
            <div className='SelfieFan__Screen__QR__Background'>
                <img src={bgImage} className='SelfieFan__Screen__Selfie__Background__Image' alt="Fondo Estadio" />
            </div>

            <div className='SelfieFan__Screen__QR__Box SelfieFan__Screen__QR__Up'>
                <div className='SelfieFan__Screen__QR__Container'>
                    <div className='SelfieFan__Screen__QR__Container__Instructions'>
                        <img src={sponsorLogo} className="SelfieFan__Screen__QR__Container__Instructions__Logo" alt="Logo Patrocinador" />
                        <p className='SelfieFan__Screen__QR__Container__Instructions__Text'>ESCANEA EL CÓDIGO Y JUEGA</p>
                    </div>
                    
                    <div className='SelfieFan__Screen__QR__Container__QR d-flex align-items-center justify-content-center bg-white p-3 rounded-4 shadow' style={{ width: '320px', height: '320px', margin: '0 auto' }}>
                        <QRCodeSVG 
                            value={qrUrl} 
                            size={280} 
                            level="H" 
                            includeMargin={false}
                        />
                    </div>
                </div>
            </div>

            <footer className='SelfieFan__Screen__QR__Footer FooterCredits'>Hecho con ♥ por Interaktia | 2026</footer>
        </>
    );
};

export { QRPluckingRooster };